import { PurchaseActionTypes } from './action-types';
export const initialPurchaseState = {
  productInfo: {
    productDisplayName: '',
    priceInUSD: 0,
    bundledProductsDisplayName: [],
    skuId: 0,
    quantity: 0
  },
  isMonthlySingleProduct: false,
  hasSeatsChanged: false,
  additionalSeats: 0
};
const purchaseReducer = (state = initialPurchaseState, action) => {
  switch (action.type) {
    case PurchaseActionTypes.SetProductInfo:
      return Object.assign({}, state, {
        productInfo: action.productInfo,
        isMonthlySingleProduct: true
      });
    case PurchaseActionTypes.SetAdditionalSeats:
      return Object.assign({}, state, {
        additionalSeats: action.additionalSeats >= 0 ? action.additionalSeats : 0
      });
    case PurchaseActionTypes.SetHasSeatsChanged:
      return Object.assign({}, state, {
        hasSeatsChanged: action.hasSeatsChanged
      });
    default:
      return state;
  }
};
export default purchaseReducer;